export default __webpack_public_path__ + "static/88-d56c79f11a020010d80afa5c8dfd23dd.gif";